import { FormattedMessage } from "react-intl";
import { navigateToParent } from "utils/boHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { ACTIONS } from "constants/constants";
import Button from "core/buttons/button/Button";
import PropTypes from "prop-types";

const AdminFooterButtons = ({ onSubmit, action }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmitMessage = () => {
    let idMessage;
    let defaultMessage;
    if (action === ACTIONS.CREATE) {
      idMessage = "admin_create_send";
      defaultMessage = "Créer";
    } else if (action === ACTIONS.UPLOAD) {
      idMessage = "admin_download";
      defaultMessage = "Télécharger";
    } else {
      idMessage = "admin_edit_send";
      defaultMessage = "Mettre à jour";
    }
    return <FormattedMessage id={idMessage} defaultMessage={defaultMessage} />;
  };
  return (
    <div
      className={`flex row ${
        action === ACTIONS.CREATE ||
        action === ACTIONS.EDIT ||
        action === ACTIONS.UPLOAD
          ? "margin-right"
          : ""
      }`}
    >
      {(action === ACTIONS.CREATE ||
        action === ACTIONS.EDIT ||
        action === ACTIONS.DETAILS ||
        action === ACTIONS.UPLOAD) && (
        <Button
          className="btn-hover-color"
          size="large"
          color="blue"
          onClick={() => navigateToParent(navigate, location)}
        >
          <FormattedMessage
            id={"admin_show_return_to_parent_page"}
            defaultMessage={"Aller à la page parente"}
          />
        </Button>
      )}
      {(action === ACTIONS.CREATE ||
        action === ACTIONS.EDIT ||
        action === ACTIONS.UPLOAD) && (
        <Button
          className="btn-hover-color"
          size="large"
          color="blue"
          onClick={onSubmit}
        >
          {handleSubmitMessage()}
        </Button>
      )}
    </div>
  );
};

export default AdminFooterButtons;

AdminFooterButtons.propTypes = {
  onSubmit: PropTypes.func,
  action: PropTypes.string,
};
